'use client';

import { PageSection } from '@components/pageSection';

import { PrimeCardSectionProps } from './types';
import { PrimeCard } from './ui/PrimeCard';

export const PrimeCardSection = (props: PrimeCardSectionProps) => {
  return (
    <PageSection childrenWrapperClassName="px-4">
      <PrimeCard {...props} />
    </PageSection>
  );
};
